module.exports = __webpack_public_path__ + "img/icon-fintech.c72202fe.png";